import React from "react";
import { Link } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import HeroButton from "./HeroButton";

function GameTile({
  game,
  index,
  isLocked = false,
  onPlay,
  showSignInPrompt = false,
  hasSubscription = false,
}) {
  const tileStyle = {
    "--game-color": game.color,
    "--index": index,
  };

  const tileClasses = `game-tile ${isLocked ? "locked" : ""}`;

  // If not locked and no custom onPlay handler, render as Link
  if (!isLocked && !onPlay) {
    return (
      <Link to={game.path} className={tileClasses} style={tileStyle}>
        <div className="game-icon-container">
          <div className="game-icon">{React.createElement(game.icon)}</div>
        </div>

        <div className="game-content">
          <h3>{game.name}</h3>
          <p>{game.description}</p>
          {game.isFree && !hasSubscription && (
            <div className="free-badge">
              <small>Start</small>
            </div>
          )}
        </div>
      </Link>
    );
  }

  // For locked games or custom handlers, render as div with button
  return (
    <div className={tileClasses} style={tileStyle}>
      <div className="game-icon-container">
        <div className="game-icon">{React.createElement(game.icon)}</div>
        {isLocked && !game.isFree && (
          <div className="lock-overlay">
            <FaLock className="lock-shadow" />
            <FaLock className="lock-icon" />
          </div>
        )}
      </div>

      <div className="game-content">
        <h3>{game.name}</h3>
        <p>{game.description}</p>

        {game.isFree && !showSignInPrompt && !hasSubscription && (
          <div className="free-badge">
            <small>Start</small>
          </div>
        )}

        {!game.isFree && !showSignInPrompt && !hasSubscription && (
          <div className="premium-badge">
            <small>Premium Game</small>
          </div>
        )}

        {onPlay && (
          <div className="game-action">
            <HeroButton
              onClick={() => onPlay(false)}
              className="game-action-button"
              size="sm"
              variant={showSignInPrompt ? "primary" : "secondary"}
            >
              {showSignInPrompt
                ? game.isFree
                  ? "Sign In to Play"
                  : "Subscribe to Play"
                : "Unlock Game"}
            </HeroButton>
            {showSignInPrompt && game.isFree && (
              <div className="why-signin-link">
                <button
                  type="button"
                  className="text-link-button"
                  onClick={() => onPlay(true)}
                >
                  Why sign in?
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default GameTile;
